import { useState } from 'react';

import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import messages from './messages';
import ValidationsTooltip from './ValidationsTooltip';
import { MoreInformationCampusNewSVG } from '../assets/svgs';
import { PASSWORD_STRENGTH_COLORS, PASSWORD_STRENGTH_STATUSES } from '../data/constants';
import {
  convertConditionsWithMessages,
  getPasswordStrengthIndex,
} from '../data/utils/passwordValidator';

const PasswordStrength = ({ value, confirmPasswordValue, style }) => {
  const [hoverTooltipIcon, setHoverTooltipIcon] = useState(false);

  const { formatMessage } = useIntl();

  const positiveConditionsLength = getPasswordStrengthIndex(value);
  const convertedConditionsToMessages = convertConditionsWithMessages(value, confirmPasswordValue, formatMessage);

  const strengthColor = PASSWORD_STRENGTH_COLORS[positiveConditionsLength];
  const strengthStatus = PASSWORD_STRENGTH_STATUSES[positiveConditionsLength];

  return (
    <div className="password-strength" style={style}>
      <div className="flex-start-column w-100">
        <div className="bar">
          <span
            style={{ display: 'inline-flex', justifyContent: 'center' }}
            onMouseEnter={() => setHoverTooltipIcon(true)}
            onMouseLeave={() => setHoverTooltipIcon(false)}
          >
            <MoreInformationCampusNewSVG
              width={15}
              height={15}
              color="rgba(50, 51, 51, 1)"
            />
          </span>
          {Array(4)
            .fill(0)
            .map((_, index) => (
              <span
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                className="bar-line"
                style={{
                  backgroundColor:
                    index <= positiveConditionsLength && strengthColor,
                }}
              />
            ))}
        </div>
        <span 
          className={`bold-text mb-0 password-feedback ${
            positiveConditionsLength <= 1 ? 'weak' : 'strong'
          }`}
        >
          {strengthStatus ? formatMessage(messages[strengthStatus]) : '\u00A0'}
        </span>
      </div>

      {hoverTooltipIcon && (
        <ValidationsTooltip
          title={formatMessage(
            messages['password.strength.the.password.must.include']
          )}
          conditions={convertedConditionsToMessages}
        />
      )}
    </div>
  );
};

PasswordStrength.propTypes = {
  value: PropTypes.string,
  confirmPasswordValue: PropTypes.string,
  style: PropTypes.shape({
    width: PropTypes.string,
  }),
};

PasswordStrength.defaultProps = {
  value: '',
  confirmPasswordValue: '',
  style: {},
};

export default PasswordStrength;
